import View from "../common/views/OverlayView";
import components from "./components.js";
components.define("js-Overlay", View);